import CardanoRoyaleSample from "../images/CardanoRoyaleSample2026.jpg"
import './HeroSection.css';

const Sample = () => (
  <section className="sample-section">
    <div className="container text-center p-sm-5">
      <img
        className="img-fluid sample-art"
        src={CardanoRoyaleSample}
        alt="CardanoRoyale0000001 - the first hand of the new deal"
      />
      <p className="sample-caption">CardanoRoyale0000001 &mdash; the first hand of the new deal</p>
    </div>
  </section>
);

export default Sample;
